<app-product-list [products]="products" [isIt]="true"> </app-product-list>
